import React from 'react';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import ProductsContainer from './ProductsContainer.jsx';
import SideMenu from './SideMenu';
class ProductsContainerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: <div /> };
  }
  componentWillMount() {
    if (this.props.products !== undefined) {
      this.createDisplayData(this.props);
    }
  }
  componentWillReceiveProps(props) {
    if (props.tabSelected != this.tabSelected || (props.products !== undefined &&
      (!(props.products || new List()).equals((this.props.products || new List()))))) {
      this.createDisplayData(props);
    }
  }
  createDisplayData(props) {
    const data = [];
    for (let i = 0; i < props.products.size; i++) {
      data.push(<ProductsContainer
        contractDate={props.deal.get(`${props.dealType}Date`)}
        tabSelected={props.tabSelected}
        key={`product-${i}-${props.products.getIn([i, 'id'], '')}`}
        idx={i}
        deal={props.deal}
        dealType={props.dealType}
        startAtomsLinking={props.startAtomsLinking}
        disabled={props.disabled}
        isLast={i == props.products.size - 1}
      />);
    }
    this.setState({ data });
  }
  render() {
    return (<div>
      <SideMenu products={this.props.products} />
      {this.state.data}
    </div>);
  }
}
ProductsContainerList.propTypes = {
  products: React.PropTypes.object,
  deal: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  tabSelected: React.PropTypes.bool,
};
export default connect((state) => ({
  deal: state.getIn(['data', 'deals', 'deal'], new Map()),
  products: state.getIn(['data', 'deals', 'deal', 'products'], new List()),
}))(ProductsContainerList);
